import Seo from "@/components/Seo";

const ABOUT_STATS = [
  { value: "6,000+", label: "Projects Delivered" },
  { value: "18+", label: "Years Experience" },
  { value: "18+", label: "Business Partnerships" },
  { value: "2008", label: "Established Since" },
];

export default function About() {
  return (
    <div data-testid="about-page">
      <Seo
        title="About ISGS — Asbestos Consulting Sydney"
        description="ISGS Consulting Group — NSW-based certified asbestos and hazmat consultants. 6,000+ projects delivered, NATA-accredited, 24/7 emergency response, 18+ years of field expertise."
        path="/about"
      />

      {/* HERO BANNER — helmet bleeds smoothly into navy with radial vignette */}
      <section className="relative overflow-hidden bg-[#0E2A5C]" data-testid="about-hero">
        {/* Background image — ISGS-branded hardhat + team handshake at sunset (moved from Contact page) */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: "url('https://customer-assets-eiarnc6j.emergentagent.net/job_draft-preview-11/artifacts/g34z77vj_ISGS%20HAT.png')",
          }}
          aria-hidden
        />
        {/* Navy overlay — opaque enough to keep text readable while the branded hat and silhouetted team read through */}
        <div className="absolute inset-0 bg-gradient-to-br from-[#0E2A5C]/70 via-[#0A1F47]/55 to-[#0E2A5C]/60" aria-hidden />
        <div className="absolute inset-0 grid-overlay opacity-15" aria-hidden />

        <div className="container-x relative z-10 py-24 lg:py-32 grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7" />

          <div className="lg:col-span-5">
            <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 rounded-full px-4 py-1.5 backdrop-blur mb-5" data-testid="who-we-are-pill">
              <span className="w-1.5 h-1.5 rounded-full bg-[#A6CD3C] animate-pulse" />
              <span className="text-[11.5px] tracking-[0.22em] uppercase font-semibold text-white">Who we are</span>
            </div>
            <div className="grid grid-cols-2 gap-3">
              {ABOUT_STATS.map((s, i) => {
                const tiles = ["bg-[#0E2A5C] text-white", "bg-[#A6CD3C] text-[#0E2A5C]", "bg-[#3B6CA8] text-white", "bg-[#0A1F47] text-white border border-[#A6CD3C]/40"];
                return (
                  <div key={s.label} className={`${tiles[i]} rounded-2xl p-5 shadow-xl backdrop-blur`} data-testid={`about-stat-${s.label.replace(/\s+/g,'-').toLowerCase()}`}>
                    <div className="text-[30px] md:text-[34px] font-bold leading-none">{s.value}</div>
                    <div className="text-[11px] uppercase tracking-[0.18em] mt-2.5 opacity-90 font-semibold">{s.label}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      {/* WHITE BANNER — ISGS's Story */}
      <section className="section-pad bg-white" data-testid="about-story">
        <div className="container-x max-w-4xl mx-auto">
          <h2 className="text-[34px] md:text-[52px] text-[#0E2A5C] leading-[1.05] font-bold mb-12 text-center tracking-tight">
            ISGS' Story
          </h2>

          <div className="space-y-6 text-[#0B0F1A]/85 text-[16.5px] md:text-[17px] leading-[1.75]">
            <p>
              Co-founded by <strong className="text-[#0E2A5C]">Ruth Guerreiro</strong>, trading since 2008, we have been growing and fostering an environment where a single family and company co-existing can change lives and create a better industry to achieve the world goal of eradicating Asbestos Containing Materials (ACMs) and successfully banning the products globally. Overlooking the Sydney beach in Brighton-Le-Sands NSW, it was the start of something that will last and change generations — one phone call for a residential project for asbestos fibre air monitoring made way and has now improved the asbestos industry we work in every day.
            </p>
            <p>
              For the past 18 years we have provided tailored services of asbestos consulting, asbestos awareness and prevented well above <strong className="text-[#0E2A5C]">5,000+ asbestos exposures</strong> in Australia alone — and unfortunately brought the unforgiving and heart-wrenching news too that there is the small chance of an asbestos-related disease to occur. Now, with the succession plan in motion being <strong className="text-[#0E2A5C]">Isaac Simnett</strong>, we will tell the truth and reality of your asbestos-related situation and plan to continue and grow our story with you.
            </p>
          </div>

          <div className="mt-16 text-center">
            <h3 className="text-[28px] md:text-[40px] text-[#0E2A5C] font-bold leading-tight italic">
              Will you be a part of it?
            </h3>
            <div className="h-[3px] w-24 bg-[#A6CD3C] mx-auto rounded-full mt-5" />
          </div>
        </div>
      </section>
    </div>
  );
}
